import { Box } from '@mui/material';
import rapchikLogoShieldSrc from '../../assets/profile/rapchik-logo-shield.svg';

/** Figma 11059:2089 — Rapchik logo (hand + rap + coin) atop RapCard shield */
export default function RapCardShieldLogo() {
  return (
    <Box
      sx={{
        position: 'absolute',
        top: '27.6px',
        left: '151px',
        width: '77.93px',
        height: '57.86px',
        pointerEvents: 'none',
      }}
    >
      <Box
        component="img"
        src={rapchikLogoShieldSrc}
        alt="Rapchik"
        sx={{ width: '100%', height: '100%', display: 'block', objectFit: 'contain' }}
      />
    </Box>
  );
}
